// extracted by mini-css-extract-plugin
export var title = "MaterialCard-module--title--jxa5j";